import PLOrderTable from "./PLOrderTable";
import DirStkTable from "./DirStkTable";
import CndnTable from "components/cndn/CndnTable";
import { useBill } from "hooks/bill";

export default function SetSaleBillMiddle({ docType }) {
  const {
    showTables,
    regularTableData,
    setTableData,
    selectBoxes,
    billHeader,
  } = useBill();

  if (!showTables) {
    return null;
  }

  // CNDN Direct(Without Item): hide item table
  if (docType === "CNDN" && billHeader.cndntype === "Direct(Without Item)") {
    return null;
  }

  return (
    <div>
      <div className="mb-10">
        <div className="sm:flex sm:items-center"></div>
        <div className="flow-root">
          <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
              <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg">
                {docType === "CNDN" ? (
                  <CndnTable />
                ) : ["PL", "ORD"].includes(selectBoxes.billType?.value) ? (
                  <PLOrderTable
                    tableData={regularTableData}
                    setTableData={(data) => setTableData(data)}
                    docType={docType}
                    billType={selectBoxes.billType?.value}
                  />
                ) : (
                  <DirStkTable docType={docType} />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
